import Vue from 'vue/dist/vue.esm.js';
export const EventBus = new Vue();